import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import { DownloadButton } from '@/components/ImportExportHistory/Table/Columns/Cells/components/DownloadButton';
import {
  ImportExportHistoryColumn,
  OnDownloadClick,
} from '@/components/ImportExportHistory/type';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC, memo, useCallback } from 'react';
import styles from '../column.module.scss';

type Props = {
  row: ImportExportHistoryColumn;
  actionHandlers?: { onDownloadClick: OnDownloadClick };
};

const cx = classnames.bind(styles);

export const FileNameCell: FC<Props> = memo(({ row, actionHandlers }) => {
  const { t } = useTranslation();
  const { id, name, can_download, type } = row;
  const hasFileName = (name ?? '') !== '';

  const handleDownloadClick = useCallback(async () => {
    actionHandlers?.onDownloadClick(id, name ?? '');
  }, [actionHandlers, id, name]);

  const showDownloadButton = type === 'import';

  return (
    <div className={cx('file-name-cell')}>
      {!hasFileName ? (
        <span>--</span>
      ) : (
        <>
          <div className={cx('file-name-container')}>
            <FileNameSeparatorWithExtension>
              {name ?? ''}
            </FileNameSeparatorWithExtension>
          </div>
          <div className={cx('button-group')}>
            {showDownloadButton && (
              <DownloadButton
                onClick={handleDownloadClick}
                isDisabled={!can_download}
                tooltipTitle={
                  !can_download
                    ? t('import_export_history_download_expired')
                    : undefined
                }
              />
            )}
          </div>
        </>
      )}
    </div>
  );
});

FileNameCell.displayName = 'FileNameCell';
